import React from 'react';
import classNames from 'classnames';

const ns = `badge`;

const Badge = ({ children, variant }) => {
	const rootClassnames = classNames({
		[`${ ns }`]: true,
		[`${ ns }--${ variant }`]: variant,
	});

	return (
		<div className={rootClassnames}>
			<span>
				{children}
			</span>
		</div>
	);
};

export default Badge;
